import { AOI_desc } from "./text";

export const skills = [
  "Python",
  "C/C++",
  "C#",
  "JavaScript",
  "TypeScript",
  "Java",
  "Swift",
  "React/React-native",
  "Expo",
  ".NET",
  "CSS",
  "HTML",
  "AWS",
  "Google Firebase",
  "Azure",
  "Databricks",
  "SQL",
  "MongoDB",
  "PostgreSQL",
  "GitHub",
  "Docker",
  "Airflow",
  "Computer Vision",
  "Azure DevOps",
  "German",
];

export const hobbies = [
  "Gaming",
  "Computer Building",
  "3D Modeling and printing",
  "Soccer",
  "Working out",
];

export const projects = [
  //   {
  //     name: "GitVoicer",
  //     skills: ["Go", "Kubernetes", "GitHub API", "Docker"],
  //     status: "In Progress",
  //     new: true,
  //     description: `GitVoicer is an automation tool I’m developing to streamline the administrative side of technical consulting. By monitoring GitHub repositories for specific triggers such as merges or releases, GitVoicer automatically generates professional invoices based on the work completed.

  // A side goal of this project is to deepen my expertise in Go and Kubernetes, focusing on building a scalable, event-driven architecture. While still in the early stages, the main roadmap for this project includes:

  //   - An AI-driven engine where repository meta data is passed to categorize tasks and create precise inline items
  //   - Exploring the integration of a Databricks pipeline to analyze repository trends, such as language distribution and velocity, providing deeper insights for future project scoping. `,
  //   },
  {
    name: "JobTracker",
    skills: ["React", "TypeScript", "Python", "FastAPI", "Databricks", "PostgreSQL", "Gmail API"],
    status: "In Progress",
    new: true,
    description: `JobTracker is a full-stack application that monitors your Gmail inbox for job application emails, automatically classifies them by company and status, and displays them on a dashboard.

On first sign-in, the app scans the last 6 months of emails using the Gmail API with Google OAuth 2.0. From there, a Databricks workflow runs hourly to process new emails through a medallion architecture — raw ingestion in Bronze, classification in Silver, and analytics-ready data in Gold — before syncing to a PostgreSQL database via Supabase.

The frontend is built with React 19 and TypeScript, and users can manually edit application statuses, add notes, and track their history across all their applications.`,
    link: "https://github.com/Kschoffner13/JobTracker",
    images: [],
  },
  {
    name: "InkBot (Capstone)",
    skills: ["C/C++", "Machine Learning", "Arduino", "React-Native"],
    status: "Completed",
    description: `For my capstone project, I developed an autonomous robot designed to automate the labor-intensive process of marking internal and external wall locations on construction sites. I was responsible for the firmware design and implementation on an ESP32, managing the integration of motor controls, marking mechanisms, and UWB-based trilateration. To facilitate seamless user interaction, I developed a custom Bluetooth communication protocol that allowed the robot to receive complex floor plans and coordinate data directly from a mobile application.

The primary technical challenge involved overcoming significant signal jitter and outliers from the UWB sensors, which initially provided accuracy only within ±10 cm. After researching and testing various filtering methods, I implemented a median-coordinate buffering system that effectively neutralized data "jumps" where standard mean-based filters failed. Additionally, I developed a movement-tracking logic that utilized pattern recognition to dynamically select the best regression model for course correction. While hardware constraints limited final accuracy to within 5 cm, the system successfully demonstrated effective autonomous navigation and achieved a 40% reduction in labor time compared to traditional manual methods.`,

    link: "https://uniquenamehere21.github.io/InkBotWeb/",
  },
  {
    name: "Stock prediction model comparison",
    skills: ["Python", "Machine Learning", "Pandas", "NumPy"],
    status: "Completed",
    description: `The stock market prediction model comparison project was a final project for a neural networks class I recently took in my fall semester.  The goal of the assignment was to  pick a scenario in which we would have to develop two different types of models to try and solve the same situation and compare the results. For our project we chose to attempt to predict stock market closing values specifically on the NASDAQ Stock Exchange. 

The two models that we ended up comparing were two RNN and based models: LSTM and GRU. My  individual contribution in this project consisted of the development of the GRU model specifically in which I outlined the model structure, Test and training Loops as well as the hyperparameter tuning for this model as we had to hyperparameter tune at least one of our models. 

We also chose to do some data scrubbing beforehand and we altered some of the values from our test data which we pulled from kaggle.  The end results show that the GRU performed better in this scenario but was likely due to the hyperparameter tuning that was performed solely on the Gru and not the LSTM model.`,

    link: "https://github.com/Kschoffner13/Stock_prediction",
  },
  {
    name: "Code Problem Fetcher API",
    skills: [".Net", "C#", "Azure", "SQL"],
    status: "In Progress",
    description: `The code problem fetcher is an API designed to interact with an Azure SQL database to retrieve leet-code style problems.

I used the .NET framework to build  the API to get familiar with developing in C#. I chose to use an SQL database Microsoft Azure as the data is not complex and I wanted it to be easy to make complex queries. Also, since I have never worked with .NET prior to this project, I figured using a microsoft service with a microsoft framework would be smoother than other options like firebase. The end goal for this project is to deploy it and use it for the code clash project and/or as an API that others can use.`,
    link: "https://github.com/Kschoffner13/code-problem-API",
    images: [],
  },
  {
    name: "FootyMetrics",
    status: "Completed",
    skills: ["React-Native", "Expo", "SQL", "javaScript"],
    description: `FootyMetrics is the one stop shop for all parents and coaches to track and export stats for players and teams alike in the game of soccer. 

I used react-native with expo for development since you dont have to use an emulator and can develop directly on your device. Since there is a considerable amount of data that needs to be stored, I used SQLite to create a local SQL database. I chose to stay away from cloud services for now since there are a number of ways to export player and team stats as CSV files, and people may not always have data to use when at the soccer pitch. 

I am currently trying in the process of getting coaches and parents to test the app on iOS before releasing it publicly on the app store. Android will come shortly after. 
`,
    link: "",
    images: [],
  },
  {
    name: "AOI (Internship)",
    status: "Completed",
    skills: ["Python", "OpenCV", "Machine   Learning"],
    description: AOI_desc,
    link: "",
    images: [],
  },
  {
    name: "CodeClash",
    status: "In Progress",
    skills: ["React", "javaScript", "Firebase"],
    description: `CodeClash is a competitive spin on the popular website leetcode, where instead of just competing problems, players compete against each other to complete problems faster or in specific ways. 

It was built using react and firebase as I wanted to try something different than AWS, something that I had used a couple of times already. I ran into some issues with finding enough data for the problems, so the project stalled for a bit. 

I need to create some scripts to do some data fetching for me before I attempt to create a database structure for the matches. The other trick is figuring out how to test the online matches which may require deployment. 

The plan also is to integrate the code problem fetcher API instead of using firebase as then the problems could be accessible from anywhere. 
`,
    link: "",
    images: [],
  },
  {
    name: "RoPro",
    status: "Completed",
    skills: ["React-Native", "Expo", "AWS", "javaScript"],
    description: `RoPro is a mobile application designed to speed up the house building process by creating printable cut lists for doors and windows. 

RoPro was the first publicly available mobile application I worked on. Me and 2 others worked on the initial version for both android and iOS in the summer between second and third of university. 

We used react-native and expo to develop the application, and used AWS as a backend, which was my primary responsibility with the addition of some front end touch ups. 

The application is currently available on both the app store and google play store. 
`,
    link: "https://apps.apple.com/ca/app/ropro/id6450377614",
    images: [],
  },
  // Add more projects as needed
];
